import { getCouponDiscount, getCouponMaxDeductAmount, getCouponThreshold } from '@/common/utils/coupon';
import { DiscountCoupon } from '../../../api';
import { View, Text } from 'react-native';
import React from 'react';
import { ThemeColorMap } from '@/hooks/abTest/useCouponPush';
import { scaleW } from '@/common/style';

function CouponMiniV2(props: { couponInfo: DiscountCoupon }) {
    const { couponInfo } = props;
    const getCouponDescription = () => {
        if (couponInfo.discountType === 3 && couponInfo.discountFeeType === 2) {
            return getCouponMaxDeductAmount(couponInfo);
        }

        return getCouponThreshold(couponInfo);
    };

    const themeColor = couponInfo.discountFeeType === 3 ? ThemeColorMap.shipping : ThemeColorMap.product;

    return (
        <View
            style={{"overflow":"hidden"}}>
            {/* 优惠券上面的圆角 */}
            <View
                style={{
                    width: scaleW(6),
                    position: 'absolute',
                    height: scaleW(6),
                    backgroundColor: 'white',
                    borderRadius: scaleW(6),
                    borderWidth: scaleW(0.5),
                    borderColor: themeColor.border,
                    top: -scaleW(3),
                    left: '50%',
                    zIndex: 1,
                }}
            />
            {/* 优惠券下面的圆角 */}
            <View
                style={{
                    width: scaleW(6),
                    position: 'absolute',
                    height: scaleW(6),
                    backgroundColor: 'white',
                    borderRadius: scaleW(6),
                    borderWidth: scaleW(0.5),
                    borderColor: themeColor.border,
                    bottom: -scaleW(3),
                    left: '50%',
                    zIndex: 1,
                }}
            />
            <View
                style={{
                    borderColor: themeColor.border,
                    backgroundColor: themeColor.background,
                    paddingHorizontal: scaleW(8),
                    paddingVertical: scaleW(6),
                    borderRadius: scaleW(4),
                    borderWidth: scaleW(0.5),
                }}>
                <Text
                    style={{
                        fontSize: scaleW(12),
                        color: themeColor.text,
                        fontWeight: '500',
                        lineHeight: scaleW(18),
                    }}>
                    {getCouponDiscount(couponInfo) + ' ' + getCouponDescription()}
                </Text>
            </View>
        </View>
    );
}

export default CouponMiniV2;
